import { Divider, Paper, Stack } from "@mui/material";

import type { ModelInfo } from "../../model/modelInfo";
import type { ModelLook } from "../../model/modelLook";
import { AnimationControls } from "./AnimationControls/AnimationControls";
import { CopyYamlButton } from "./CopyYamlButton/CopyYamlButton";
import { MaterialControls } from "./MaterialControls/MaterialControls";
import { ModelDetails } from "./ModelDetails/ModelDetails";
import { PanelSection } from "./PanelSection/PanelSection";
import "./SettingsPanel.css";
import { SliderField } from "./SliderField/SliderField";
import { TransformControls } from "./TransformControls/TransformControls";

interface SettingsPanelProps {
  model: { fileName: string; info: ModelInfo } | null;
  look: ModelLook;
  onLookChange: (look: ModelLook) => void;
  playingClip: string | null;
  onPlayClip: (clipName: string | null) => void;
  bloomStrength: number;
  onBloomStrengthChange: (strength: number) => void;
}

export function SettingsPanel({
  model,
  look,
  onLookChange,
  playingClip,
  onPlayClip,
  bloomStrength,
  onBloomStrengthChange
}: SettingsPanelProps) {
  if (!model) return null;

  return (
    <Paper square elevation={0} className="settings-panel" data-testid="viewer-panel">
      <Stack spacing={3} divider={<Divider />}>
        <ModelDetails fileName={model.fileName} info={model.info} />
        <TransformControls info={model.info} look={look} onLookChange={onLookChange} />
        <MaterialControls slots={model.info.slots} look={look} onLookChange={onLookChange} />
        <AnimationControls clipNames={model.info.clipNames} playingClip={playingClip} onPlayClip={onPlayClip} />
        <PanelSection title="Rendering">
          <SliderField label="Bloom" value={bloomStrength} min={0} max={4} step={0.05} onChange={onBloomStrengthChange} />
        </PanelSection>
        <CopyYamlButton fileName={model.fileName} look={look} />
      </Stack>
    </Paper>
  );
}
